module.exports = __webpack_public_path__ + "media/images/brand/errors/error-0a63b59c0bf5e17959d5bd0e00641caf.jpeg";